import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const restoreSupportingDocument: (
  fetchContext: FetchContext,
  nominationId: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, nominationId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/nominations/${nominationId}/supporting-documents/restoration`,
  {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'restore supporting document'));
